import { CONTENT_TYPES } from '@/constants';
// eslint-disable-next-line import/no-extraneous-dependencies
const cheerio = require('cheerio');

export const normalizeContent = (data) => {
  const blocks = data?.contents || [];

  let contentNavigationTitles = {};
  const updatedContent = blocks.map((contentItem) => {
    if (contentItem.type === CONTENT_TYPES.html) {
      const $ = cheerio.load(contentItem.content.replace(/&nbsp;/g, ' '), {
        xmlMode: true,
      });

      // отримуємо заголовки з блоку html
      $('h2, h3').each((index, element) => {
        // додаємо атрибути для підсвічування меню
        $(element).addClass('sections').attr('id', $(element).text());
        contentNavigationTitles = {
          ...contentNavigationTitles,
          [contentItem.id]: [
            ...(contentNavigationTitles?.[contentItem.id] || []),
            {
              label: $(element).text(),
              id: $(element).text(),
            },
          ],
        };
      });

      return {
        ...contentItem,
        content: $.html(),
      };
    }

    return contentItem;
  });

  const content = updatedContent.reduce((result, block) => {
    const arr = result;
    if (!result[block.position]) {
      arr[block.position] = [];
    }
    arr[block.position].push(block);

    return arr;
  }, {});
  const filters = (typeof data.filters === 'object' && data.filters) || {};

  return {
    meta: data.meta,
    contentBlocks: content,
    tableOfContent: contentNavigationTitles,
    filters,
  };
};

export default normalizeContent;
